module.exports = __webpack_public_path__ + "static/media/17m.81aca466.svg";